import { useMinimalOutfitterQuery } from "~graphql/outfitters.generated"

export default function useMinimalOutfitter({
    id,
}: {
    id: string | null | undefined
}) {
    const {
        data,
        loading: isLoading,
        error,
    } = useMinimalOutfitterQuery({
        variables: { id: id ?? "" },
        skip: !id,
    })
    const outfitter = data?.outfitter ?? null

    return { outfitter, isLoading, error }
}
